export default __webpack_public_path__ + "static/media/Add_to_Apple_Wallet_rgb_RU.8f236765.svg";